module.exports = __webpack_public_path__ + "static/img/logo0.12f03b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo0.png
// module id = kJ/V
// module chunks = 0